<template>
    <div class="preview-panel-inner h-full">
        <div class="step-wrapper" v-show="step === 0">
            <ChooseATheme class="choose-theme"></ChooseATheme>
        </div>
        <div class="step-wrapper" v-show="step >= 1 && step <= 3">
            <WaveDesignPreview></WaveDesignPreview>
        </div>
        <div class="step-wrapper h-full" v-show="step >= 4 && step <= 5">
            <PreviewResult></PreviewResult>
        </div>
    </div>
</template>


<script type="text/javascript">
import { mapFields } from 'vuex-map-fields';
import ChooseATheme from './PreviewPanel/0_Choose_Theme/ChooseATheme.vue';
import WaveDesignPreview from './PreviewPanel/1-4_WaveDesign/WaveDesignPreview.vue';
import PreviewResult from "./PreviewPanel/5-6_PreviewResult/PreviewResult.vue";

export default {
    components: {
        ChooseATheme,
        WaveDesignPreview,
        PreviewResult
    },
    computed: {
        ...mapFields([
            'step'
        ])
    },
    methods: {

    }
};
</script>
